<template>
<picture v-if="valid" :class="className">
  <template v-for="(size,key) in sizes">
    <source v-if="sizes[key]" :srcset="imgset.sizes[key]" :media="size">
  </template>
  <img :src="defaultImage" :width="imgset.attributes.width" :height="imgset.attributes.height" :alt="imgset.attributes.alt" />
  </picture>
</template>
<script type="text/javascript">

export default {
  props: {
    imgset: {},
    sizes: {},
    className: '',
    defaultSize: {
      type: String,
      default: 'max_720x720'
    }
  },
  data: function() {
    return {
      valid: false,
      defaultImage: ''
    }
  },
  created: function() {
    if (this.imgset.sizes instanceof Object && this.imgset.sizes !== null) {
      if (this.imgset.attributes instanceof Object) {
        if (this.imgset.attributes.width) {
          if (this.imgset.sizes) {
            this.valid = true
          }
        }
      }
      if (this.valid) {
        if (this.imgset.sizes.hasOwnProperty(this.defaultSize)) {
          this.defaultImage = this.imgset.sizes[this.defaultSize]
        }
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// VuePicture.vue?e6f3a504